module.exports = __webpack_public_path__ + "img/screen-manual-16.9d847688.png";